import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";
import formControl from "globals/form-control";



const operationURLS = {
  list: "/dnd/list",
  update: "/dnd/update",
  create: "/dnd/create",
  delete: "/dnd/delete",
};

const getColumns = (onDelete, onEdit) => {
  return [
    {
      Header: "Phone Number",
      accessor: "phoneNo",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width:6,
      validation: formControl.string().required("Required").digitsOnly(),
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Reference Number",
      accessor: "refNo",
      displayInList: true,
      allowInForm: true,
      allowFilter: true,
      dataType: "string",
      width:6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Action",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getColumns, operationURLS };
